import React, { useState, useEffect } from 'react';
import './App.css';
import './BackToTop.css'
import Header from './components/Header.js';
import Hero from './components/Hero.js';
import About from './components/About.js';
import Projects from './components/Projects.js';
import Footer from './components/Footer.js';
import BackToTopButton from './BackToTop.js'; 

function App() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) { // Show button after scrolling past 100px
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll); // Cleanup
  }, []);






  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Projects />
      <Footer />
      <div>
      {/* Your page content */}
      {showButton && <BackToTopButton />}
    </div>
      
    </div>
  );
}

export default App;
